import { Menu, MenuButton, MenuList, MenuItem, Portal } from '@chakra-ui/core'
import React from 'react'
import { setCommentContext } from 'redux/actions/feed'
import LocaleText from 'components/LocaleText'
import { ReactComponent as OverflowMenu } from 'assets/overflow-menu.svg'
import { useDispatch } from 'react-redux'
import colors from 'constants/colors'
import { useLockScrollOnElementRole } from 'hooks/useLockScrollOnElementRole'

interface MessageMenuProps {
  isUserMessage: boolean
  isAdminCommentsPermission: boolean
  deleteCommentHandler: (cid: string) => void
  isShowEmojiAndReplyPicker: boolean
  cid: string
}

export const MessageMenu = ({
  isUserMessage,
  isAdminCommentsPermission,
  deleteCommentHandler,
  isShowEmojiAndReplyPicker,
  cid,
}: MessageMenuProps) => {
  const dispatch = useDispatch()
  useLockScrollOnElementRole('scrollableDiv', 'menu')

  if (!isUserMessage && !isAdminCommentsPermission && !isShowEmojiAndReplyPicker) {
    return null
  }

  return (
    <Menu closeOnBlur closeOnSelect>
      <MenuButton outline="none" tabIndex={0} onClick={(e) => e.stopPropagation()}>
        <OverflowMenu />
      </MenuButton>

      <MenuList placement="auto">
        {(isUserMessage || isAdminCommentsPermission) && (
          <MenuItem
            onClick={() => {
              deleteCommentHandler(cid)
            }}
            color={colors.red}
          >
            <LocaleText text="delete" />
          </MenuItem>
        )}
        {isUserMessage && (
          <MenuItem
            onClick={() => {
              dispatch(setCommentContext({ commentId: cid, isEdit: true }))
            }}
          >
            <LocaleText text="edit" />
          </MenuItem>
        )}
        {isShowEmojiAndReplyPicker && (
          <MenuItem
            onClick={() => {
              dispatch(setCommentContext({ commentId: cid, isEdit: false }))
            }}
          >
            <LocaleText text="reply" />
          </MenuItem>
        )}
      </MenuList>
    </Menu>
  )
}
